import React from "react";
import { useLocation } from "react-router-dom";

const MessageView = () => {
  const location = useLocation();

  const contact = location?.state;

  return (
    <div className="px-12 my-6">
      <h2 className="text-2xl font-semibold text-gray-800 mb-5">
        Message From Website
      </h2>

      <div className="space-y-4 p-5 border rounded">
        <div className="flex gap-x-2">
          <span className="font-medium text-gray-600 w-20">Name</span>
          <span className="text-gray-800">: {contact?.name}</span>
        </div>

        <div className="flex gap-x-2">
          <span className="font-medium text-gray-600 w-20">Email</span>
          <span className="text-gray-800">: {contact?.email}</span>
        </div>

        <div className="flex gap-x-2">
          <span className="font-medium text-gray-600 w-20">Mobile</span>
          <span className="text-gray-800">: {contact?.mobile}</span>
        </div>

        <div className="flex gap-x-2">
          <span className="font-medium text-gray-600 w-20">Subject</span>
          <span className="text-gray-800">: {contact?.subj}</span>
        </div>

        <div>
          <span className="font-medium text-gray-600 block mb-1">Message</span>
          <p className="text-gray-800 bg-gray-50 p-3 rounded border border-gray-200 min-h-[60px]">
            {contact?.messg}
          </p>
        </div>

        <div className="flex gap-x-2">
          <span className="font-medium text-gray-600 w-20">Received</span>
          <span className="text-gray-800">
            : {new Date(contact?.created_at).toLocaleString()}
          </span>
        </div>
      </div>
    </div>
  );
};

export default MessageView;
